import { useState } from "react";
import { Button, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import WorkspacesRoundedIcon from "@mui/icons-material/WorkspacesRounded";
import ActionHeaderCard from "../General/ActionHeaderCard";
import ConfirmDialog from "../General/Dialog/ConfirmDialog";
import CreateTaskDialog from "./CreateTaskDialog";
import WorkspaceBoard from "./WorkspaceBoard";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { deleteWorkspaceTask } from "../../services/WorkspaceService";

export default function ManagerWorkspace() {
  const { hasPermission } = useAuth();
  const { showToast } = useToast();

  const [openCreate, setOpenCreate] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [boardRefresh, setBoardRefresh] = useState(0);

  const refreshBoard = () => setBoardRefresh((n) => n + 1);

  const handleDelete = async () => {
    if (!taskToDelete) return;
    setDeleting(true);
    try {
      await deleteWorkspaceTask(taskToDelete.id);
      setTaskToDelete(null);
      showToast("Tarea eliminada correctamente.", "success");
      refreshBoard();
    } catch (error) {
      console.error("[ManagerWorkspace] Error al eliminar tarea:", error);
      showToast(
        error?.response?.data?.message || "No se pudo eliminar la tarea.",
        "error",
      );
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12 }}>
        <ActionHeaderCard
          icon={<WorkspacesRoundedIcon />}
          title="Área de Trabajo"
          description="Tablero para organizar y dar seguimiento a las tareas del estudio."
          action={
            hasPermission("crear tarea") ? (
              <Button
                onClick={() => setOpenCreate(true)}
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ borderRadius: 2, fontWeight: 800, textTransform: "none" }}
              >
                Nueva tarea
              </Button>
            ) : null
          }
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <WorkspaceBoard
          refreshSignal={boardRefresh}
          onEdit={setEditingTask}
          onDelete={setTaskToDelete}
          onCreate={hasPermission("crear tarea") ? () => setOpenCreate(true) : undefined}
        />
      </Grid>

      <CreateTaskDialog
        open={openCreate || !!editingTask}
        task={editingTask}
        onClose={() => {
          setOpenCreate(false);
          setEditingTask(null);
        }}
        onCreated={refreshBoard}
      />

      <ConfirmDialog
        open={!!taskToDelete}
        onClose={() => setTaskToDelete(null)}
        onConfirm={handleDelete}
        title="Eliminar tarea"
        description="¿Eliminar esta tarea del área de trabajo? Esta acción no se puede deshacer."
        confirmText={deleting ? "Eliminando..." : "Eliminar"}
        cancelText="Cancelar"
        confirmColor="error"
        loading={deleting}
      />
    </Grid>
  );
}
